import * as React from "react";
import { Spin } from "antd";
import CheckboxGroup from "../../components/app/CheckboxGroup";
import Text from "antd/lib/typography/Text";
import { IRuleGroupsPresentationModel } from "../../../presenter/evaluation/EvaluationTypesPresenter";

export interface State {}

export interface Props {
  translate: any;
  assignedRuleGroupsIds?: number[];
  ruleGroups?: IRuleGroupsPresentationModel[];
  onRuleGroupSelectChange?: any;
  ruleGroupLoader?: boolean;
}

export default class EvaluationTypesDataGrid extends React.Component<
  Props,
  State
> {
  render() {
    const {
      translate,
      assignedRuleGroupsIds,
      ruleGroups,
      ruleGroupLoader,
      onRuleGroupSelectChange
    } = this.props;

    return (
      <div>
        <Spin spinning={ruleGroupLoader}>
        <h3>{translate("evaluationTypes_page.select_rule_group")}</h3>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {ruleGroups && ruleGroups.length ? (
              <CheckboxGroup
                options={ruleGroups}
                onChange={e => {
                  onRuleGroupSelectChange(e);
                }}
                value={assignedRuleGroupsIds}
                columnCount={2}
              />
            ) : (
              <Text>{translate("data_grid.empty_text")}</Text>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
